import type { FC } from 'react';
import { Auth } from './Auth';
import { Countries } from './Countries';
import { Loading } from './Loading';
import { Globe } from './Globe';
import { ChatBot } from './ChatBot';
import { Product } from './Product';
import { Profile } from './Profile';
import { EducationCareer } from './EducationCareer';
import { LabourDemandPulse } from './LabourDemandPulse';
import { HeatMap } from './HeatMap';
import { Occupations } from './Occupations';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './azureADAuthConfig';
import { ISCOArchetype } from './ISCOArchetype';

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const msalInstance = new PublicClientApplication(msalConfig);

const ContextGlobalProvider: FC<{}> = ({ children }) => {
    return (
        <MsalProvider instance={msalInstance}>
            <Auth>
                <Countries>
                    <Globe>
                        <Product>
                            <Profile>
                                <HeatMap>
                                    <EducationCareer>
                                        <LabourDemandPulse>
                                            <Occupations>
                                                <ISCOArchetype>
                                                    <ChatBot>
                                                        <Loading>{children}</Loading>
                                                    </ChatBot>
                                                </ISCOArchetype>
                                            </Occupations>
                                        </LabourDemandPulse>
                                    </EducationCareer>
                                </HeatMap>
                            </Profile>
                        </Product>
                    </Globe>
                </Countries>
            </Auth>
        </MsalProvider>
    );
};

export default ContextGlobalProvider;
